import { Component, OnInit } from '@angular/core';
import {BaseSelectComponent} from "../base-select/base-select.component";
import {GestionErreursService} from "../../../services/gestion-erreurs.service";
import {RegimeService} from "../../../services/repositories/regime.service";
import {AppUtilsService} from "../../../services/internals/app-utils.service";
import { CommonModule } from '@angular/common';
import { InputFieldComponent } from '../../form-generator/fields/input-field/input-field.component';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-select-regime',
  templateUrl: './select-regime.component.html',
  styleUrls: ['./select-regime.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    InputFieldComponent,
    IonicModule,
    TranslateModule
  ]
})
export class SelectRegimeComponent extends BaseSelectComponent {

  constructor(
    private regimeService: RegimeService,
    private _appUtils: AppUtilsService,
    private _gestionErreursService: GestionErreursService,
  ) {
    super(regimeService, _appUtils, _gestionErreursService);
  }

}
